import { CSSProperties, useEffect, useRef, useState } from 'react';
import { accentSpotlightShades } from './accentSpotlight';

const SPOTLIGHT_CLASS = 'landing-pricing-spotlight';
const PAUSED_CLASS = 'landing-pricing-spotlight--paused';

export function useAccentSpotlight(accentColor: string) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(true);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), {
      rootMargin: '200px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const { from, to } = accentSpotlightShades(accentColor);

  return {
    ref,
    className: inView ? SPOTLIGHT_CLASS : `${SPOTLIGHT_CLASS} ${PAUSED_CLASS}`,
    style: {
      '--landing-spotlight-from': from,
      '--landing-spotlight-to': to
    } as CSSProperties
  };
}
